module.exports = __webpack_public_path__ + "static/media/bird-blue-jay2.69a18e98.aac";